import React from 'react';
import { isNumber } from 'lodash';
import { useTranslation } from 'react-i18next';
import { StyleProp, Text, TextProps, TextStyle } from 'react-native';
import { fontSizes } from 'src/themes/Metrics';

interface Props extends TextProps {
  children?: any;
  fontWeight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
  color?: string;
  fontSize?: keyof typeof fontSizes | number;
  textAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify';
  textAlignVertical?: 'auto' | 'top' | 'bottom' | 'center';
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  style?: StyleProp<TextStyle>;
  textLang?: string;
}

export const RegularText = ({
  color = 'black',
  fontSize = 'regular',
  // fontSize = 'large',
  textAlign = 'left',
  children,
  style,
  fontWeight,
  textTransform,
  textAlignVertical,
  textLang,
  ...props
}: Props) => {
  const { t } = useTranslation();
  return (
    <Text
      {...props}
      style={[
        {
          fontSize: isNumber(fontSize) ? fontSize : fontSizes[fontSize],
          color,
          textAlign,
          fontWeight,
          textTransform,
          textAlignVertical,
        },
        style,
      ]}>
      {textLang ? t(textLang) : children}
    </Text>
  );
};
